import http from "../index";

export const getProducts = () => http.get("/product");
